var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-header__parent"},[_c('div',{staticClass:"wrapper"},[_c('h5',[_vm._v(_vm._s(_vm.moduleName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }